const MERCHANDISING_STATES = {
  PENDING: 'pending',
  VALIDATED: 'validated',
  REJECTED: 'rejected',
};

export default angular
  .module('sfMobile.constants.merchandising', [])
  .constant('SF_MERCHANDISING_STATES', MERCHANDISING_STATES).name;
